import React from 'react';

import OneBlue from 'src/assets/icon-1-blue.png';
import OnePeach from 'src/assets/icon-1-peach.png';

import TwoBlue from 'src/assets/icon-2-blue.png';
import TwoPeach from 'src/assets/icon-2-peach.png';

import ThreeBlue from 'src/assets/icon-3-blue.png';
import ThreePeach from 'src/assets/icon-3-peach.png';

import PhonePeach from 'src/assets/icon-phone-peach.png';
import PhoneBlue from 'src/assets/icon-phone-blue.png';

import ClinicalPeach from 'src/assets/icon-clinical-peach.png';
import ClinicalBlue from 'src/assets/icon-clinical-blue.png';

import MedicationPeach from 'src/assets/icon-medication-peach.png';
import MedicationBlue from 'src/assets/icon-medication-blue.png';

import * as classes from 'src/components/blocks/blockSignposting.module.scss';
import classnames from 'classnames';

// theme: 'light' or 'dark'

const SignpostElement = ({ title, description, numberIcon, icon, theme }) => {
  return (
    <div className={classnames(classes.signpostingElementContainer)}>
      <div className={classes.signpostElementTopContainer}>
        <img src={numberIcon} className={classes.hidden} alt="" />
        <img className={classes.icon} src={icon} alt="" />
      </div>
      <div className={classes.signpostElementBottomContainer}>
        <img src={numberIcon} alt="" />
        <div className={classes.signpostingTextContainer}>
          <div className={classes.signpostElementTitle}>{title}</div>
          <div className={classes.signpostElementContent}>{description}</div>
        </div>
      </div>
    </div>
  );
};

const BlockSignposting = ({ theme }) => {
  return (
    <div
      className={classnames(
        classes.blockSignpostingLayoutContainer,
        theme === 'light'
          ? classes.blockSignpostingLayoutContainerMediumBreakpoint
          : classes.blockSignpostingLayoutContainerLargeBreakpoint,
      )}
    >
      <div
        className={classnames(
          classes.blockSignpostingContainer,
          theme === 'light' ? classes.light : undefined,
          theme === 'light'
            ? classes.blockSignpostingContainerMediumBreakpoint
            : classes.blockSignpostingContainerLargeBreakpoint,
        )}
      >
        <SignpostElement
          title="Download app"
          description={`Set up your account ~5 min`}
          icon={theme === 'light' ? PhonePeach : PhoneBlue}
          numberIcon={theme === 'light' ? OnePeach : OneBlue}
          theme={theme}
        />
        <SignpostElement
          title="Meet with a provider"
          description="Via a private and secure phone video visit!"
          icon={theme === 'light' ? ClinicalPeach : ClinicalBlue}
          numberIcon={theme === 'light' ? TwoPeach : TwoBlue}
          theme={theme}
        />
        <SignpostElement
          title="Pick up prescription"
          description="From your pharmacy, often same day!"
          icon={theme === 'light' ? MedicationPeach : MedicationBlue}
          numberIcon={theme === 'light' ? ThreePeach : ThreeBlue}
          theme={theme}
        />
      </div>
    </div>
  );
};

export default BlockSignposting;
